<style scoped lang="scss">
@import '../scss/login.scss';
.login-template{
  background:url('../img/login-bg.jpg') no-repeat center top;
  background-size:cover
}
.person-info-modal{
  .v-dialog{
    .v-card__text{
      padding:0 24px;
    }
    .v-card__title{
      &.inform{
        padding-top:0;
      }
    }
    .desc-wrap{
      height:150px;
    }
    .btns{
      padding-bottom:20px;
    }
  }
}
</style>
<template>
  <div class="login-template">
    <div class="left-column" data-hidden="mobile">
      <p class="tit">
        고객의 물류 시작부터 끝까지<br>전문가가 설계하는<br><strong>위탁재고 맞춤 관리 서비스</strong>
      </p>
      <div class="copyright">
        <img src="../img/copyright.png" alt="YONGMALOGIS - COPYRIGHT 2022 YONGMA LOGIS, ALL RIGHTS RESERVED">
      </div>
    </div>
    <div class="login-wrap">
      <div class="logo-row">
        <img src="../img/oms-default-logo.png" alt="CIMS-OMS" data-hidden="mobile">
        <img src="../img/mobile/login-logo.png" alt="CIMS-OMS" data-hidden="desktop">
      </div>
      <div class="login-form">
        <legend class="blind">로그인</legend>
        <div class="input-row">
          <input
            type="text"
            class="default-input"
            id="login-id"
            v-model="userId"
            required
            autocomplete="off"
          />
          <label for="login-id" class="default-label">ID</label>
          <div class="bar"></div>
        </div>
        <div class="input-row">
          <input
            type="password"
            class="default-input"
            id="login-password"
            maxlength="20"
            v-model="userPassword"
            v-on:keyup.enter="clickLogin"
            required
          />
          <label for="login-password" class="default-label">Password</label>
          <div class="bar"></div>
        </div>
        <div class="btn-row">
          <!--<router-link to="/main" class="button default default-btn">
            LOGIN
          </router-link>-->
          <button class="button default default-btn" @click="clickLogin()">
            LOGIN
          </button>
        </div>
        <div class="chk-row">
          <input type="checkbox" id="maintain-status" class="default-chk" v-model="checked" />
          <label for="maintain-status" class="chk-label">ID 저장하기</label>
          <!--<button type="button" class="pwd-find-btn" @click="findPassword()">비밀번호 찾기</button>-->
        </div>
      </div>
    </div>
    <div data-app>
      <v-dialog
        v-model="personalInform"
        persistent
        max-width="500px"
        id="person-info-modal"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">개인정보수집, 이용 및 제공 등에 관한 고지</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <div class="desc-wrap">
                    {{ personalInformDesc }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                  class="ui-col text-center"
                >
                  <v-checkbox color="primary" v-model="personalInformVal" label="위의 고지내용에 동의합니다.">
                  </v-checkbox>
                  <v-btn
                    color="blue darken-1"
                    class="default-btn-style"
                    text
                    @click="userStateChk"
                  >
                    확인
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    class="close-btn-style"
                    style="margin-left:10px"
                    text
                    @click="personalInform = false"
                  >
                    취소
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div data-app>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="400px"
        id="user-info-modal"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">비밀번호 찾기</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="ID*"
                    required
                    v-model="findId"
                    oninput="javascript: this.value = this.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '' );"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col 
                  cols="12"
                  md="12">
                  <v-text-field
                    label="Email"
                    required
                    v-model="findEmail"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="setFindPassword()"
              >
                임시비밀번호 발급
            </v-btn>
            </v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dialog = false"
            >
              닫기
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div data-app>
      <v-dialog
        v-model="passwordDialog"
        persistent
        max-width="400px"
        id="password-info-modal"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ userPopupTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="ID*"
                    required
                    disabled
                    v-model="userId"
                    oninput="javascript: this.value = this.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '' );"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col 
                  cols="12"
                  md="12">
                  <v-text-field
                    type="password"
                    label="이전 Password"
                    required
                    maxlength="20"
                    v-model="prePassword"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col 
                  cols="12"
                  md="12">
                  <v-text-field
                    type="password"
                    label="변경 Password"
                    required
                    v-model="nextPassword"
                    maxlength="20"
                    :rules="rules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col 
                  cols="12"
                  md="12">
                  <v-text-field
                    type="password"
                    label="변경 Password 확인"
                    required
                    v-model="confirmPassword"
                    maxlength="20"
                    :rules="rulesCheck"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col 
                  cols="12"
                  md="12">
                  <span class="text-h6" style="color:rgba(255,0,0,.6)">숫자 + 문자 + 특수문자 포함 8~20자리로 설정해주세요.</span>
                  <span class="text-h6" style="color:rgba(255,0,0,.6)">사용 가능 특수 문자 : !@#$%^*+=-</span>
                </v-col>
              </v-row>
            </v-container>
            <!--<small>*indicates required field</small>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer class="password-edit">
              <v-btn
                class="default-btn-style save-btn"
                color="blue darken-1"
                text
                @click="setChangePassword()"
              >
                저장
            </v-btn>
            <v-btn
              class="close-btn-style close-btn"
              color="blue darken-1"
              text
              @click="passwordDialog = false"
            >
              닫기
            </v-btn>
          </v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div data-app>
      <v-dialog
        v-model="monthInform"
        persistent
        max-width="500px"
        id="month-info-modal"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">비밀번호 변경 안내</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <div class="notice-wrap">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#0F4C81"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
                    </div>
                    <div class="text">
                      <strong>고객님의 개인정보보호를 위해 <span>비밀번호</span>를 변경해 주세요.</strong>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <div class="notice-desc">
                    - 90일간 비밀번호를 변경하지 않고 사용중이신 분에게 비밀번호 변경에 대해 안내 드립니다.<br>
                    - 동일한 비밀번호를 장기간 사용하실 경우 개인정보 유출로 인한 피해 위험이 높으므로 비밀번호를 변경해주시기 바랍니다.
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                  class="ui-col text-center"
                >
                  <v-btn
                    color="blue darken-1"
                    class="default-btn-style"
                    text
                    @click="passwordChangeNow"
                  >
                    지금 변경하기
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    class="close-btn-style"
                    style="margin-left:10px"
                    text
                    @click="passwordMonthMark"
                  >
                    한달간 표기 안함
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PersonInformData } from './personInform/PersonInform.js'
let personInform = PersonInformData

export default {
  name: 'Login',
  data() {
    return {
      userId: '',
      userPassword: '',
      checked: false,
      dialog: false,
      findEmail: '',
      findId: '',
      passwordDialog: false,
      rules: [
        value => this.setPassRules(value) 
        /*value => !!value || '비밀번호를 입력해주세요.',
        value => (/^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,20}$/.test(value) === true) || '숫자,영문자,특수문자 조합 8~20자리로 사용해야 합니다.',
        value => (/(?=.*[^a-zA-Z0-9!@#$%^*+=-])/.test(value) === false) || '사용할 수 없는 문자가 있습니다.'*/

      ],
      rulesCheck: [
        value => this.setCheckRules(value)
        /*value => !!value || '비밀번호 확인을 입력해주세요.',
        value => value === this.nextPassword || '패스워드가 일치하지 않습니다'*/
      ],
      mainUserName: '',
      mainUserId: '',
      prePassword: '',
      nextPassword: '',
      confirmPassword: '',
      passFlag: false,
      personalInform: false,
      personalInformVal: false,
      personalInformProVal: false,
      personalInformDesc: '',
      personalCompany: 'jnj',
      userFirstYn: '',
      userLastyn: '',
      userPrivateYn: '',
      userPopupTitle: '비밀번호 변경안내',
      monthInform: false,
      privateFirstAgree: 'N'
    }
  },
  methods: {
    clickLogin() {
      //이거로 접근
      if (this.userId === '') {
        this.$swal({
          title: 'ID를 입력해주세요!'
        })
        return
      }
      if (this.userPassword === '') {
        this.$swal({
          title: '비밀번호를 입력해주세요!'
        })
        return
      }
      if (this.checked) {
        localStorage.setItem('saveId', this.userId)
      } else {
        localStorage.clear()
      }
      this.$loading.show({delay:0})
      this.$store.dispatch('apiLoginData', {'userId': this.userId, 'userPwd': this.userPassword}).then(() => {
        this.mainUserId = this.userId
        //console.log('this.rtnLogin = ' + JSON.stringify(this.rtnLogin))
        if (this.rtnLogin.code !== 'FAIL') {
          // 로그인 성공 시
          // userFirstYn: 첫번째 로그인 했을때 -> 비밀번호 변경 창
          if(this.rtnLogin.loginInfo[0].userFirstYn === 'Y') {
            this.userPopupTitle = '최초 비밀번호 변경'
            this.passwordDialog = true
            return
          }
          // userPrivateYn: 개인정보동의화면
          
          if(this.rtnLogin.loginInfo[0].userPrivateYn === 'N'){
            this.personalInform = true
            this.personalInformDesc = personInform[0].text
            return
          }

          // userLastyn: 3개월 지났을때 -> 비밀번호 변경, 1개월연장
          // console.log(this.rtnLogin.loginInfo[0])
          if(this.rtnLogin.loginInfo[0].userLastYn === 'Y') {
            this.userPopupTitle = '비밀번호 변경안내'
            this.monthInform = true
            return
          }
          
          sessionStorage.clear()
          sessionStorage.setItem('userInfo', JSON.stringify(this.rtnLogin.loginInfo))
          sessionStorage.setItem('realKey', this.rtnLogin.gridKey)
          if(this.privateFirstAgree == 'Y'){
            sessionStorage.setItem('firstYn', this.privateFirstAgree) 
          }
          
          window.realGrid2Lic = this.rtnLogin.gridKey

          this.$router.push('/main')
        } else {
          this.$swal({
            title: this.rtnLogin.message
          })
        }
      }).catch((error) => {
        this.$swal({
          title: 'ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.'
        })
      }).finally(() => {
        setTimeout(() => {
          this.$loadingHide()
        }, 300);
      })
    },
    userStateChk(){
      if(this.personalInformVal === true) {
          this.$loading.show({delay:0})
          this.$store.dispatch('updateUser', {'userId': this.userId, 'changeType': 'privteAgree', 'userPrivateYn': 'Y'}).then(() => {
            this.personalInform = false
            this.privateFirstAgree = 'Y'
            this.clickLogin()
          }).catch((error) => {
            this.$swal({
              title: 'ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.'
            })
          }).finally(() => {
          setTimeout(() => {
            this.$loadingHide()
          }, 300);
        })
      } else {
        this.$swal({
          title: '개인정보 수집 및 정보처리 통신망의 동의하셔야 이용가능합니다.'
        })
        return
      }
    },

    findPassword(){
      this.dialog = true
      this.findId = ''
      this.findEmail = ''
    },
    setFindPassword(){
      if (this.findId === '') {
        this.$swal({
          title: 'ID를 입력해주세요.'
        })
        return
      }

      if (this.findEmail === '') {
        this.$swal({
          title: '가입 시 입력한 Email을 입력해주세요.'
        })
        return
      }

      // var initPassword = this.$getInitPassword()
      
      // console.log(initPassword)
    },
    setPassRules(value) {
      this.passFlag = false
      if (value === '') {
        return '비밀번호를 입력해주세요.'
      }else if (/^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,20}$/.test(value) === false){
        return '숫자,영문자,특수문자 조합 8~20자리로 사용해야 합니다.'
      }else if (/(?=.*[^a-zA-Z0-9!@#$%^*+=-])/.test(value) === true) {
        return '사용할 수 없는 문자가 있습니다.'
      }else{
        this.passFlag = true
        return true
      }
    },
    setCheckRules(value){
      this.checkFlag = false
      if (value === '') {
        return '비밀번호 확인을 입력해주세요.'
      }else if(this.nextPassword === ''){
        return '변경 비밀번호를 입력해주세요'
      }else if (value !== this.nextPassword) {
        return '패스워드가 일치하지 않습니다'
      }else{
        this.checkFlag = true
        return true
      }
    },
    setChangePassword(){
      if(this.passFlag === false) {
        this.$swal({
          title: 'Password로 사용할 수 없습니다.\n다시 입력해 주세요.'
        })
        return
      }

      if (this.nextPassword !== this.confirmPassword) {
        this.$swal({
          title: '입력한 패스워드가 다릅니다'
        })
        return
      }
      this.$loading.show({delay:0})
      
      var obj = {userId: this.mainUserId, changeType: 'password', userPwd: this.prePassword, userNextPwd: this.confirmPassword}

      if (this.rtnLogin.loginInfo[0].userFirstYn === 'Y') {
        obj.userFirstYn = 'Y'
      }

      this.$store.dispatch('apiUserSelfPwTran', obj).then(() => {
        if(this.loginPwTran.code === 'SUCCESS') {
          this.passwordDialog = false
          this.userPassword = ''
          this.$swal({
            title: '비밀번호가 변경되었습니다.'
          })
          //this.clickLogin()
        } else if (this.loginPwTran.code === "CUR_PW_ERROR"){ // 기존 비밀번호가 안 맞을 때
          this.$swal({
            title: this.loginPwTran.message
          })
        }else {
          this.$swal({
            title: this.loginPwTran.message
          })
        }
      }).catch((error) => {
        this.$swal({
          title: 'ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.'
        })
      }).finally(() => {
        setTimeout(() => {
          this.$loadingHide()
        }, 300);
      })
    },
    passwordChangeNow(){
      this.monthInform = false
      this.passwordDialog = true
    },
    passwordMonthMark(){
      this.$loading.show({delay:0})
        this.$store.dispatch('updateUser', {'userId': this.userId, 'changeType': 'monthLater', 'userMonthYn': 'Y'}).then(() => {
        }).catch((error) => {
          this.$swal({
            title: 'ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.'
          })
        }).finally(() => {
        setTimeout(() => {
          this.monthInform = false
          this.$loadingHide()
          this.clickLogin()
        }, 300);
      })
    }
    
  },
  mounted() {
    var id = localStorage.getItem('saveId')
    // console.log('id = ' + id)
    if (id !== null) {
      this.userId = id
      this.checked = true
    }

    setTimeout(() => {
      this.$loadingHide()
    }, 300);
    // this.setFindPassword()
  },
  computed: {
    ...mapGetters({
      rtnLogin: 'getUserLogin',
      loginPwTran: 'getUserSelfPwTran'
    })
  },
}
</script>
